import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Person from "./Person";
import ImportExcel from "./ImportExcel";
import SendSms from "./Crm/SendSms";
import CampaignMaker from './Campaign/CampaignMaker';
import CrmBaseFields from "./Crm/CrmBaseFields";
import CrmCaseDo from "./Crm/CrmCaseDo";

export default class Persons extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'person',
            caller: this.isBlank(props.Caller) ? "persons" : props.Caller,
            data: null,
            loading: true,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 18
        };
        this.setMenuId();
        this.state.filters = {
            caller: this.state.caller,
            crmSourceId: this.getDefaultGuid(),
            mobile: '',
            nationalId: '',
            categoryName: '',
            mobileList: false,
            emailList: false
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        if (props.Caller == this.state.caller) return;
        this.state.caller = props.Caller;
        this.state.filters.caller = this.state.caller;
        this.setMenuId();
        this.refreshData();
    }
    setMenuId() {
        if (this.state.caller === "customers") this.state.menuId = 107;
        if (this.state.caller === "staffs") this.state.menuId = 108;
    }
    showBaseFields() {
        this.removeKeyDown();
        this.showComponents({ component: <CrmBaseFields Caller={this} /> });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Person Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Person Caller={this} /> });
    }
    onImport() {
        this.removeKeyDown();
        this.showComponents({ component: <ImportExcel Caller={this} Type={2} CompanyId={this.state.data.global.company.id} /> });
    }
    onContact(personId) {
        this.removeKeyDown();
        this.showComponents({
            component: <CrmCaseDo Caller={this} CrmCaseLogType={2} PersonId={personId} />
        });
    }
    sendSms() {
        this.removeKeyDown();
        this.httpPost("api/v1/" + this.state.controllerName + "/list", {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            filters: this.state.filters,
            mobileList: true
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    var mobiles = [];
                    data.records.forEach(mobile => {
                        if (!this.isEmpty(mobile.mobile)) {
                            mobiles.push(mobile.mobile);
                        }
                    });
                    this.showComponents({
                        component: <SendSms Mobiles={mobiles} Caller={this} UseIn={'persons'} />
                    });
                }
                this.setState({
                    loading: false
                });
            })
    }
    createCampaign() {
        this.removeKeyDown();
        this.httpPost("api/v1/" + this.state.controllerName + "/list", {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            filters: this.state.filters,
            emailList: true,
            outputFormat: 'json'
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    var emails = [];
                    data.records.forEach(mobile => {
                        if (!this.isEmpty(mobile.email)) {
                            emails.push(mobile.email);
                        }
                    });
                    this.showComponents({
                        component: <CampaignMaker Service={1} OrganizationId={this.state.data.global.company.id} Emails={emails} Caller={this} />
                    });
                }
                this.setState({
                    loading: false
                });
            })
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست اشخاص</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} شخص یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><span className="shortcut">F2 - </span><span>ایجاد شخص جدید</span></a>
                                        </li>
                                        {this.state.caller === "persons" && <li>
                                            <a onClick={e => this.onImport()} className="hand btn btn-success">ورود اکسل</a>
                                        </li>}
                                        {this.state.caller === "persons" && <li>
                                            <a onClick={e => this.refreshData(e, "list", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>}
                                        {this.state.caller === "persons" && <li>
                                            <NavLink to="/personcategories/" className="hand btn btn-warning">گروه ها</NavLink>
                                        </li>}
                                        {this.state.caller === "persons" && <li>
                                            <a onClick={e => this.showBaseFields()} className="hand btn btn-warning">فیلدهای سفارشی</a>
                                        </li>}
                                        <li id="PersonsSendSmsLink"><a onClick={e => this.sendSms()} className="hand btn btn-warning">ارسال پیامک</a></li>
                                        {this.state.data.global.user.role === 1 && <li><a onClick={e => this.createCampaign()} className="hand btn btn-warning">کمپین ایمیل</a></li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="نام" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.mobile} onChange={e => this.state.filters.mobile = e.target.value} placeholder="شماره موبایل" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.nationalId} onChange={e => this.state.filters.nationalId = e.target.value} placeholder="کدملی" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.categoryName} onChange={e => this.state.filters.categoryName = e.target.value} placeholder="عنوان گروه" className="form-control" />
                                            </div>
                                            <div className="form-wrap" id="PersonsCrmSourceFilter">
                                                <select defaultValue={this.state.filters.crmSourceId} onChange={e => this.state.filters.crmSourceId = e.target.value} className="form-control input-sm">
                                                    <option value={this.getDefaultGuid()}>همه سرنخ ها</option>
                                                    {this.state.data.crmSources.map(cat => <option value={cat.id}>{cat.title}</option>)}
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ شخصی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">کد</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">نام</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">گروه</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">نوع</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">کدشعبه</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره تماس</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">کد/شناسه ملی</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">کداقتصادی</span></div>
                                            <div className="nk-tb-col text-center" id="PersonsCrmSorceColumnHeader"><span className="sub-text">سرنخ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">موبایل</span></div>
                                            <div className="nk-tb-col text-center" id="PersonsRemainColumnHeader"><span className="sub-text">مانده</span></div>
                                            <div className="nk-tb-col text-center" id="PersonsTashkhisColumnHeader"><span className="sub-text">تشخیص</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">کد: </span>
                                                    <span className="sub-text text-center">{record.code}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">نام: </span>
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                            {record.name}
                                                        </a>
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">گروه: </span>
                                                    <span className="sub-text text-center">{record.categories.map(cat => <span style={{ "background-color": "#f8a602", "borderRadius": "4px", "padding": "2px", "margin": "0 2px", "display": "inline-block" }} >{cat.name}</span>)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">نوع: </span>
                                                    <span className="sub-text text-center">{record.typeString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">کد شعبه: </span>
                                                    <span className="sub-text text-center">{record.branchCode}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">شماره تماس: </span>
                                                    <span className="sub-text text-center">{record.phone}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">کد/شناسه ملی: </span>
                                                    <span className="sub-text text-center">{record.nationalId}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">کداقتصادی: </span>
                                                    <span className="sub-text text-center">{record.economicCode}</span>
                                                </div>
                                                <div className="nk-tb-col" id="PersonsCrmSorceColumnValue">
                                                    <span className="onlyMobile">سرنخ: </span>
                                                    <span className="sub-text text-center">{record.crmSourceTitle}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">موبایل: </span>
                                                    <span className="sub-text text-center">{record.mobile}</span>
                                                </div>
                                                <div className="nk-tb-col" id="PersonsRemainColumnValue">
                                                    <span className="onlyMobile">مانده: </span>
                                                    <span className="sub-text text-center">{this.money(record.balance)}</span>
                                                </div>
                                                <div className="nk-tb-col" id="PersonsTashkhisColumnValue">
                                                    <span className="onlyMobile">تشخیص: </span>
                                                    <span className="sub-text text-center">{record.balanceDirection === 0 ? "" : record.balanceDirection === 1 ? "بدهکار" : "بستانکار"}</span>
                                                </div>
                                                <div className="nk-tb-col text-end">
                                                    <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                        <em className="icon ni ni-cross-fill-c"></em>
                                                    </a>
                                                    <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                        <em className="icon ni ni-pen"></em>
                                                    </a>
                                                    <a id="PersonsCrmContactLink" className="hand text-success mx-1" onClick={e => this.onContact(record.id)} title="ثبت سابقه ارتباطی">
                                                        <em className="icon ni ni-chat-circle"></em>
                                                    </a>
                                                    {record.code > 0 && <NavLink id="PersonsTransactionReportLink" className="hand text-warning mx-1" to={"/report/transaction/1/" + record.code + "/"} title="مشاهده تراکنش های حساب">
                                                        <em className="icon ni ni-file-docs"></em>
                                                    </NavLink>}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                ,
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}